import { useState } from "react";

import { PARTNER_BANKS } from "@/data/content";

function BankLogo({ bank }) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div
        className="text-[#0F2D52] font-heading font-bold text-lg text-center"
        title={bank.name}
      >
        {bank.name}
      </div>
    );
  }

  return (
    <img
      src={bank.logo}
      alt={bank.name}
      loading="lazy"
      className="h-full max-h-12 md:max-h-14 w-auto object-contain grayscale hover:grayscale-0 mm-transition"
      onError={() => setFailed(true)}
    />
  );
}

export default function PartnerBanks() {
  const doubled = [...PARTNER_BANKS, ...PARTNER_BANKS];

  return (
    <section
      id="partners"
      data-testid="partner-banks"
      className="py-16 md:py-20 bg-[#F8FAFC] border-y border-gray-200/70"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-8">
        <span className="text-[11px] uppercase tracking-[0.18em] font-bold text-gray-500">
          Trusted Banking Partners
        </span>

        <h2 className="mt-2 text-2xl sm:text-3xl font-bold font-heading tracking-tight text-[#0F2D52]">
          We facilitate applications with 30+ banks & NBFCs
        </h2>

        <p className="mt-2 text-sm text-gray-500 max-w-2xl mx-auto">
          Suitability of lender depends on your profile, loan type and product
          policies of the respective institution.
        </p>
      </div>

      <div className="relative overflow-hidden">
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#F8FAFC] to-transparent z-10" />

        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#F8FAFC] to-transparent z-10" />

        <div className="marquee-track flex items-center gap-10 md:gap-16 py-4">
          {doubled.map((bank, index) => (
            <div
              key={`${bank.name}-${index}`}
              data-testid={`bank-logo-${index}`}
              className="shrink-0 h-14 md:h-16 flex items-center justify-center px-4 opacity-80 hover:opacity-100 mm-transition"
              title={bank.name}
            >
              <BankLogo bank={bank} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
